// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { useParams } from 'react-router-dom';
import { useQuery, getQueryParams } from '../../lib/utility';
import { S } from './ExamReviewPageStyle';
import * as Markdown from '../../components/Markdown';
import ScrollToTop from './components/ScrollToTop';
import ImgPopUp from './components/ImgPopUp';
import { FormattedMessage } from 'react-intl';
import FileUpload from '../ExamPage/components/FileUpload';
import LoadingIcon from '../../components/LoadingIcon';
import { Link } from 'react-router-dom';
import ConfirmSubmit from './components/ConfirmSubmit';
import { HandsOnCompletionStatusType } from '../../types/Model';
import {
  useExamData,
  useSubmitReview
} from './hooks';

interface examResultData {
  answerList: any,
  answerQaList: any,
  correctNumber: number,
  score: number,
  status: string,
  wrongNumber: number,
}

interface examTypeData {
  percent: string,
  expectedNumberOfQuestion: string,
  totalNumberOfQuestion: number,
}

function ExamReviewPage(): JSX.Element {
  const params = useParams<{ token: string }>();
  const [activeIndex, setActiveIndex] = useState<string>('MultiSelect');
  const token = params.token;
  const query = getQueryParams(useQuery()) as { id: string };
  const examRecordId = parseInt(query.id);

  const [isLoading, setIsLoading] = useState(true);
  const [examResult, setExamResult] = useState<examResultData>();
  const [examQnaResult, setExamQnaResult] = useState(
    () => {
      const cacheExamList = localStorage.getItem('reviewQnaList_' + examRecordId);
      if (cacheExamList) {
        return JSON.parse(cacheExamList);
      } else {
        return [];
      }
    });
  const [examId, setExamId] = useState('');
  const [examName, setExamName] = useState('');
  const [multiSelectInfo, setMultiSelectInfo] = useState<examTypeData>();
  const [qnaInfo, setQnaInfo] = useState<examTypeData>();
  const [revieweeEmail, setRevieweeEmail] = useState('');
  const [isSubmit, setIsSubmit] = useState(false);
  const [examStatus, setExamStatus] = useState<HandsOnCompletionStatusType>(HandsOnCompletionStatusType.NOREVIEW);
  const [error, setError] = useState(false);
  const [fileOverSize, setFileOverSize] = useState(false);
  const [showImgUp, setShowImgUp] = useState(false);
  const [showImgUpImg, setShowImgUpImg] = useState('');
  const [baseUrl, setBaseUrl] = useState('');
  const [answerUrl, setAnswerUrl] = useState('');
  const [reviewUrl, setReviewUrl] = useState('');
  const [clickSubmit, setClickSubmit] = useState(false);
  const [haveSubmit, setHaveSubmit] = useState(false);
  const [reviewScore, setReviewScore] = useState(0);

  const getExamData = async () => {
    const result = await useExamData(examRecordId, token);
    if (result.message) {
      setError(true);
    } else {
      if (result.isSubmit) {
        setIsSubmit(true);
        setExamQnaResult(result.reviewList);
        setReviewUrl(result.reviewUrl);
        setExamStatus(HandsOnCompletionStatusType.REVIEWED);
      } else {
        const qnaList = result.examResult.answerQaList;
        qnaList.forEach((item: any) => {
          item.comment = '',
          item.score = 0
        });
        setExamQnaResult(qnaList);
        const cacheListName = 'reviewQnaList_' + examRecordId;
        const cacheExamList = localStorage.getItem(cacheListName);

        if (cacheExamList) {
          setExamQnaResult(JSON.parse(cacheExamList));
        } else {
          setExamQnaResult(qnaList);
          localStorage.setItem('reviewQnaList_' + examRecordId, JSON.stringify(qnaList));
        }
      }

      setExamResult(result.examResult);
      setExamId(result.examId);
      setBaseUrl(result.markdownUrl);
      setAnswerUrl(result.answerUrl)
      setExamName(result.examName.cht);
      setRevieweeEmail(result.revieweeEmail);
      setMultiSelectInfo(result.multiSelect);
      setQnaInfo(result.qna);
      if (result.examResult.answerList && result.multiSelect.expectedNumberOfQuestion !== '0') {
        setActiveIndex('MultiSelect');
      } else {
        setActiveIndex('Q&A');
      }
    }
    setIsLoading(false);
  }

  useEffect(() => {
    getExamData();
  }, [])

  const switchIndex = (index: string) => {
    setActiveIndex(index)
  }

  const checkSubmit = () => {
    let totalSize = 0;
    examQnaResult.forEach((item: any) => {
      if (item.fileSize) {
        totalSize = totalSize + item.fileSize;
      }
    });
    if (totalSize > 6*1024*1024) {
      setFileOverSize(true);
    } else {
      let finalScore = 0;
      examQnaResult.map((item: any) => {
        if (parseFloat(item.score)) {
          finalScore = finalScore + parseFloat(item.score);
        }
      })
      setFileOverSize(false);
      setReviewScore(finalScore);
      setClickSubmit(true);
    }
  }

  const handleSubmit = async () => {
    setIsLoading(true);
    const result = await useSubmitReview(examRecordId, examQnaResult, token, examId);
    if (!result) {
      localStorage.removeItem('reviewQnaList_' + examRecordId);
      setHaveSubmit(true);
      setIsLoading(false);
    }
  }

  const ExamInfo = (props: any) => {
    const examInfo = props.examInfo;
    const eachExamPoint = parseInt(examInfo.percent)/parseInt(examInfo.expectedNumberOfQuestion);

    return (
      <S.ExamInfo>
        <S.ExamInfoItem>
          <S.ExamInfoTitle><FormattedMessage id="K027" /></S.ExamInfoTitle>
          <S.ExamInfoValue>{examInfo.percent}</S.ExamInfoValue>
        </S.ExamInfoItem>
        <S.ExamInfoItem>
          <S.ExamInfoTitle><FormattedMessage id="K028" /></S.ExamInfoTitle>
          <S.ExamInfoValue>{examInfo.expectedNumberOfQuestion}</S.ExamInfoValue>
        </S.ExamInfoItem>
        <S.ExamInfoItem>
          <S.ExamInfoTitle><FormattedMessage id="K029" /></S.ExamInfoTitle>
          <S.ExamInfoValue>{eachExamPoint.toFixed(2)} <FormattedMessage id="K030" /></S.ExamInfoValue>
        </S.ExamInfoItem>
      </S.ExamInfo>
    )
  }

  const MultiSelectSection = (props: any) => {

    const multiSelectList = props.questionList;
    const multiSelectInfo = props.multiSelectInfo;

    const ChoosedAnswer = (props: any) => {
      const wrongAnswer = props.wrongAnswer;
      return (
        <>
          { wrongAnswer.map((item: any, index: number) => {
            return (
              <S.ChoosedAnswer key={index}>
                <Markdown.ExamMarkdown markdown={item} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
              </S.ChoosedAnswer>
            )
          })}
        </>
      )
    }

    const CorrectAnswer = (props: any) => {
      const correctAnswer = props.correctAnswer;
      return (
        <>
          { correctAnswer.map((item: any, index: number) => {
            return (
              <S.CorrectAnswer key={index}>
                <Markdown.ExamMarkdown markdown={item} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
              </S.CorrectAnswer>
            )
          })}
        </>
      )
    }

    const QuestionArea = (props: any) => {
      const topicContent = props.topicContent;
      return (
        <>
          <S.ChoosedAnswerList>
            <S.AnswerTitle>Choosed Answer :</S.AnswerTitle>
            { topicContent.choosedAnswer.length === 0 ? null : <ChoosedAnswer wrongAnswer={topicContent.choosedAnswer}/>}
          </S.ChoosedAnswerList>
          <S.CorrectAnswerList>
            <S.AnswerTitle>Correct Answer :</S.AnswerTitle>
            { topicContent.answers.length === 0 ? null : <CorrectAnswer correctAnswer={topicContent.answers}/>}
          </S.CorrectAnswerList>
        </>
      )
    }

    return (
      <S.ExamScoreWrap>
        <S.ExamTopicArea>
          <ExamInfo examInfo={multiSelectInfo} />
          { multiSelectList.length === 0 ? (
            <>
              <S.QuestionsAllCorrect/>
              <S.NoWrongQuestionText>
                All multiple select questions are correct!
              </S.NoWrongQuestionText>
            </>
          ) : (
            <>
              { multiSelectList.map((item: any, index: number) => {
                return (
                  <S.ExamTopic key={index}>
                    <S.ExamTopicQuestion>
                      <S.ExamTopicNumber><p>{parseInt(item.title)+1}.</p></S.ExamTopicNumber>
                      <S.ExamTopicText>
                        <Markdown.ExamMarkdown markdown={item.question} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
                      </S.ExamTopicText>
                    </S.ExamTopicQuestion>
                    <S.ExamTopicContent>
                      <QuestionArea topicContent = {item}/>
                    </S.ExamTopicContent>
                  </S.ExamTopic>
                )
              })}
            </>
          ) }
        </S.ExamTopicArea>
        <ScrollToTop></ScrollToTop>
        {/* <ImgPopUp img={showImgUpImg} showImgUp={showImgUp} setShowImgUp={setShowImgUp} /> */}
      </S.ExamScoreWrap>
    )
  }

  const QASection = (props: any) => {
    const QAList = props.questionList;
    const qnaInfo = props.qnaInfo;

    const CommentInput = (props: any) => {
      const [score, setScore] = useState(props.score);
      const [comment, setComment] = useState(props.comment);
      const [file, setFile] = useState(props.file);
      const [isOver, setIsOver] = useState(false);
      const [overText, setOverText] = useState(false);
      const index = props.index;
      const limitScore = props.limitScore;

      const QAScore = (questionTitle: number, value: any, type: string) => {
        //只能輸入數字及小數點
        let rightValue = value.replace(/[^\d.]/g, '');
        //只能一個小數點
        rightValue = rightValue.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        const reviewList = examQnaResult;
        if (type === 'score') {
          if (rightValue > limitScore) {
            setIsOver(true);
          } else {
            reviewList[questionTitle][type] = rightValue;
            setScore(rightValue);
            setIsOver(false);
          }
        } else if (type === 'comment') {
          if (value.length < 5000) {
            rightValue = value;
            reviewList[questionTitle][type] = rightValue;
            setComment(value);
            setOverText(false);
          } else {
            setOverText(true);
          }
        }
        setExamQnaResult(reviewList);
        localStorage.setItem('reviewQnaList_'+ examRecordId, JSON.stringify(reviewList));
      }

      const QnaReviewFileSection = (props: any) => {
        const file = props.file;

        return (
          <S.FileAnswerContainer>
            { file ? (
              <>
                { file.includes('jpg') || file.includes('png') || file.includes('jpeg') ? (
                  <S.AnswerImg src={reviewUrl+'/'+file} alt={file}/>
                ) : (
                  <>
                    <S.AnswerFileIcon />
                    <S.AnswerDownloadLink href={reviewUrl+'/'+file} download={file}>{file}</S.AnswerDownloadLink>
                  </>
                )}
              </>
            ) : null}
          </S.FileAnswerContainer>
        )
      }

      const handleUpload = (file: any, base64Data: any) => {
        console.log(file);
        setFile(file);
        const reviewList = examQnaResult;
        reviewList[index]['reviewFileName'] = file.name;
        reviewList[index]['fileSize'] = file.size;
        reviewList[index]['reviewFile'] = base64Data;
        setExamQnaResult(reviewList);
      }

      return (
        <>
          <S.ExamQAAnswerTitle><FormattedMessage id="K032" /></S.ExamQAAnswerTitle>
          <S.ExamQAScore value={score} isOver={isOver} min={0} onChange={ (e) => { QAScore(index, e.target.value, 'score') } } disabled={isSubmit}/>
          { isOver ? <S.ExamQAScoreTip><FormattedMessage id="K037" values={{limitScore: limitScore}} /></S.ExamQAScoreTip> : null}
          <S.ExamQAAnswerTitle><FormattedMessage id="K033" /></S.ExamQAAnswerTitle>
          <S.ExamQAText value={comment} onChange={ (e) => { QAScore(index, e.target.value, 'comment') } } disabled={isSubmit}/>
          { overText ? <S.OverText><FormattedMessage id="K042" /></S.OverText> : null}
          { isSubmit ? <QnaReviewFileSection file={props.reviewFile}/> : <FileUpload handleUpload={handleUpload} uploadFile={file}/> }
        </>
      )
    }

    const QnaFileSection = (props: any) => {
      const fileName = props.fileName;
      const answerUrl = props.answerUrl;

      return (
        <S.FileAnswerContainer>
          { fileName.includes('jpg') || fileName.includes('png') || fileName.includes('jpeg') ? (
            <S.AnswerImg src={answerUrl+'/'+fileName} alt={fileName}/>
          ) : (
            <>
              <S.AnswerFileIcon />
              <S.AnswerDownloadLink href={answerUrl+'/'+fileName} download={fileName}>{fileName}</S.AnswerDownloadLink>
            </>
          )}
        </S.FileAnswerContainer>
      )
    }

    return (
      <S.ExamScoreWrap>
        <S.ExamTopicArea>
          <ExamInfo examInfo={qnaInfo} />
          { QAList.map((item: any, index: number) => {
            return (
              <S.ExamTopic key={index}>
                <S.ExamTopicQuestion>
                  <S.ExamTopicNumber><p>{parseInt(item.title)+1}.</p></S.ExamTopicNumber>
                  <S.ExamTopicText>
                    <Markdown.ExamMarkdown markdown={item.question} setShowImgUpImg={setShowImgUpImg} setShowImgUp={setShowImgUp} baseUrl={baseUrl}/>
                  </S.ExamTopicText>
                </S.ExamTopicQuestion>
                <S.ExamTopicContent>
                  <S.ExamQAAnswerTitle><FormattedMessage id="K031" /></S.ExamQAAnswerTitle>
                  <S.ExamQAText value={item.answers} disabled/>
                  { item.fileName ? <QnaFileSection fileName={item.fileName} answerUrl={answerUrl}/> : null}
                  <CommentInput score={item.score} comment={item.comment} index={item.title} file={item.file} reviewFile={item.reviewFileName} limitScore={parseInt(qnaInfo.percent)/parseInt(qnaInfo.expectedNumberOfQuestion)}/>
                </S.ExamTopicContent>
              </S.ExamTopic>
            )
          })}
          { fileOverSize ? <S.FileOverSize><FormattedMessage id="K038" /></S.FileOverSize> : null}
          <S.ReviewActionContainer>
            { isSubmit ? (
              <FormattedMessage id="K035" />
            ) : (
              <S.ReviewBtn onClick={() => { checkSubmit() }}><FormattedMessage id="K003" /></S.ReviewBtn>
            )}
          </S.ReviewActionContainer>
        </S.ExamTopicArea>
        <ScrollToTop></ScrollToTop>
      </S.ExamScoreWrap>
    )
  }

  const renderLoading = () => {
    return (
      <S.LoadingContainer>
        <LoadingIcon size={20} />
      </S.LoadingContainer>
    )
  }

  if (error) {
    return (
      <MainLayout>
        <S.ErrorContainer>
          <S.ErrorForbiddenImage alt="error" />
          <S.ErrorText><FormattedMessage id="K036" /></S.ErrorText>
          <S.ErrorButton as={Link} to={'/'} ><FormattedMessage id="F004" /></S.ErrorButton>
        </S.ErrorContainer>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      { isLoading ? renderLoading() : (
        haveSubmit ? (
          <S.SubmitContainer>
            <S.SubmitCard>
              <S.ExamReviewSubmitIcon/>
              <S.SubmitTitle>
                <FormattedMessage id="K035" />
              </S.SubmitTitle>
              <S.BackToHomeBtn to="/home"><FormattedMessage id="F017" /></S.BackToHomeBtn>
            </S.SubmitCard>
          </S.SubmitContainer>
        ) : (
          examResult &&
          <S.Container>
            <S.Wrapper>
              <S.ExamReviewHeader>
                <S.ExamReviewTitle>
                  <S.ExamReviewUserName><S.HightlightIcon /><FormattedMessage id="K020" />{revieweeEmail}</S.ExamReviewUserName>
                  <S.ExamReviewExamName><FormattedMessage id="K021" />{examName}</S.ExamReviewExamName>
                  <S.ExamReviewExamStatus><FormattedMessage id="K039" /><S.CompletionStatusTag type={examStatus} /></S.ExamReviewExamStatus>
                </S.ExamReviewTitle>
                <S.ExamReviewSelect>
                  <S.ExamReviewScore><FormattedMessage id="K022" />{examResult?.score}</S.ExamReviewScore>
                  <S.ExamNumber>
                    <S.ExamReviewCorrect><FormattedMessage id="K023" />{examResult?.correctNumber}</S.ExamReviewCorrect>
                    <S.ExamReviewWrong><FormattedMessage id="K024" />{examResult?.wrongNumber}</S.ExamReviewWrong>
                  </S.ExamNumber>
                </S.ExamReviewSelect>
              </S.ExamReviewHeader>
              <S.TabNavigation>
                { examResult?.answerList && multiSelectInfo?.expectedNumberOfQuestion !== '0' ? <S.TabLink isAcitve={activeIndex === 'MultiSelect' ? true : false} onClick={() => { switchIndex('MultiSelect') }}><FormattedMessage id="K025" /></S.TabLink> : null}
                { examResult?.answerQaList ? <S.TabLink isAcitve={activeIndex === 'Q&A' ? true : false} onClick={() => { switchIndex('Q&A') }}><FormattedMessage id="K026" /></S.TabLink> : null }
              </S.TabNavigation>
              { activeIndex === 'MultiSelect' ? (
                <MultiSelectSection multiSelectInfo={multiSelectInfo} questionList={examResult.answerList} />
              ) : (
                <QASection qnaInfo={qnaInfo} questionList={examQnaResult} />
              )}
              { clickSubmit ? (
                <ConfirmSubmit
                  setClickSubmit={setClickSubmit}
                  handleSubmit={handleSubmit}
                  totalScore={qnaInfo?.percent}
                  reviewScore={reviewScore}
                />
              ): null }
            </S.Wrapper>
          </S.Container>
        )
      )}
    </MainLayout>
  )
}

export { ExamReviewPage as default };
